import './DressingRoomPage';
import './CharacterEditor';
import './MyPlanPage';
import { initializeApp } from 'firebase/app';
import {
  getAuth,
  onAuthStateChanged,
} from 'firebase/auth';
import { API_ENDPOINT } from './constants';
import ModelMeAIAnalytics from '../service/ModelMeAiAnalyticsService';

const firebaseConfig = {
  apiKey: "AIzaSyBpephMV4gjsISTmP27phGLmcw3jr5uT4Y",
  authDomain: "modelmeai.firebaseapp.com",
  projectId: "modelmeai",
  storageBucket: "modelmeai.firebasestorage.app",
  messagingSenderId: "588699124362",
  appId: "1:588699124362:web:98cbabfc1439b6f898e373",
};

initializeApp(firebaseConfig);
const auth = getAuth();

// Exchange the Firebase ID token for a local session cookie
async function exchangeIdToken(user) {
  if (!user) return;
  const idToken = await user.getIdToken(true);
  await fetch(`${API_ENDPOINT}/auth/firebase`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ idToken }),
    credentials: 'include',
  });
}

// --------------------------
// Minimal Router
// --------------------------
function renderPage() {
  const app = document.getElementById('app');
  if (!app) return;

  const path = window.location.pathname;
  app.innerHTML = '';

  if (path.startsWith('/character-editor')) {
    const editor = document.createElement('character-editor');
    app.appendChild(editor);
  } else if (path.startsWith('/my-plan')) {
    const myPlan = document.createElement('my-plan-page');
    app.appendChild(myPlan);
  } else {
    // Default route => dressing room
    const dressingRoom = document.createElement('dressing-room');
    app.appendChild(dressingRoom);
  }
}

// Trigger re-render on history changes
window.addEventListener('popstate', () => {
  renderPage();
  ModelMeAIAnalytics.getPlausible()
});

window.addEventListener('DOMContentLoaded', async () => {
  // Wait for auth state
  onAuthStateChanged(auth, async (user) => {
    if (user) {
      // We have a user => exchange token => show nav + page
      await exchangeIdToken(user);
      //renderNav(user);
      renderPage();
    } else {
      renderPage();
    }
  });
});

